(ns hai.notes.sections
  "The note-flavored face of [[hai.entity.sections]]."
  (:require
   [hai.entity.sections :as sections]))

(defn note-extras
  "Tags and links (URLs, contacts, notes, tasks) for a note. All show at rest as
   chips, collapsing to an \"icon +N\" pill past a small count; while editing
   every chip shows and each row gains a dashed \"＋\" control (and a section's
   adder replaces it once opened). On a blank note being edited the two \"＋\"
   triggers share a row. Renders nothing when there's nothing to show.

   A thin note-flavored wrapper over [[sections/entity-extras]] — it fixes the
   copy and maps `note-uuid` to the generic `entity-uuid`; every other prop
   passes straight through.

   `render-tag-search` is required whenever tags can show.
   `render-entity-search`, if supplied, turns the ＋ link input into a
   searchable contact/note/task dropdown; omit it to keep the plain URL-only
   adder. `on-open-entity`, if supplied, is called with the linked note/task
   map when its chip is clicked — the host owns routing."
  [{:keys [note-uuid] :as props}]
  [sections/entity-extras
   (-> props
       (dissoc :note-uuid)
       (assoc :entity-uuid note-uuid
              :tag-tooltip-text  "Tag this note to find it with related work"
              :link-tooltip-text "Attach a page, contact, note or task to this note"))])
